export default "/credits/business/assets/afb2d77746b30ed47f489b32e3f0cab1.png";